<template>
   <div v-if="ulanitem!=null">
        <a v-bind:href="'http://vocab.getty.edu/page/ulan/'+ulanitem.getty_external_id" target="_blank">  
            <img class="ui mini rounded right floated image" src="/static/getty-logo.png"  style="margin-bottom:20px;margin-top:5px;"/>
            <h4 class="ui header" style="margin:0px 0px 10px 0px">{{ulanitem.display_name}}</h4>
        </a>
        <span v-if="ulanitem.hasOwnProperty('description')" class="italic">{{ulanitem.description}}<br><br></span>
        Nationality: <br>
        {{ulanitem.nationality}}<br><br>
        <span v-if="ulanitem.hasOwnProperty('altname')">
            <span  v-for="(item,index) in ulanitem.altname.slice(0, 25)" :key="index">{{item}}, </span>
            <span  v-if="ulanitem.altname.length>25">...</span>
        </span>
        
        <br><br>
        
        
   </div>
</template>

<script>
    export default {
        props: ['ulanid'],
        data() {
            return {
                ulanitem: null,
            }
        },

        methods: {
            hasOwnDeepProperty: function(obj, path) {
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },
        },

        mounted() {

            axios
                .get('/api/ulan/' + this.ulanid) //!!!!
                .then(response => (this.ulanitem = response.data))
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .italic {
        font-style: italic;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheGettyUlan.vue